// extracted by mini-css-extract-plugin
module.exports = {"filtersSubmitButton":"Vr7xRi","fullWidth":"amc9Y9","categoryPage":"a669pI"};